import {BX24} from "../../hooks/BX24";
import {change_loading, set_users} from "../reducers/main_reducer";

export const ThunkSetUsers = () => {
    return async (dispatch) => {
        dispatch(change_loading(true))

        const users = await BX24('user.get', {'UF_DEPARTMENT' : 78, 'ACTIVE': 'true'})
        dispatch(set_users(users.result))

        dispatch(change_loading(false))
    }
}